import { html, TemplateResult } from 'lit';
import { ImpressionsList } from '../types/types.js';

/**
 * Render intro section with title and description
 * @param impressionsList - Impressions list object with title and intro text
 * @returns Lit template result
 */
export const renderIntro = (impressionsList: ImpressionsList): TemplateResult => {
    return html`
        <span class="sup-title">${impressionsList.supTitle}</span>
        <h2 class="sup-head-title">${impressionsList.title}</h2>
        <p class="sup-description">${impressionsList.intro}</p>
    `;
};
